import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDebounce } from 'use-debounce';
import { ContactLibraryListDocument } from './ContactLibraryList.gql';
export function useGetContacts(options) {
    const { searchKey, searchValue, limit, offset } = options;
    const [debouncedSearchValue, setDebouncedSearchValue] = useDebounce(searchValue, 450);
    const [writing, setWriting] = useState(false);
    useEffect(() => {
        setWriting(true);
        setDebouncedSearchValue(searchValue);
    }, [searchValue, setDebouncedSearchValue]);
    const where = {};
    if (searchKey && debouncedSearchValue.length) {
        where[searchKey] = { contains: debouncedSearchValue };
    }
    if (options.visibility === 'public') {
        where.isPublic = { eq: true };
    }
    if (options.visibility === 'private') {
        where.isPublic = { eq: false };
    }
    const { data: currentData, previousData, error, loading: queryLoading, refetch, } = useQuery(ContactLibraryListDocument, {
        fetchPolicy: 'cache-and-network',
        variables: {
            limit,
            offset,
            where,
        },
        onCompleted: () => setWriting(false),
    });
    const loading = queryLoading || writing;
    const data = (currentData === null || currentData === void 0 ? void 0 : currentData.esigningRecipientValues) || (previousData === null || previousData === void 0 ? void 0 : previousData.esigningRecipientValues);
    return {
        data,
        loading: !error && loading,
        error,
        refetch,
    };
}
